// Tips Registry
// Each tip has a key, version, and i18n keys for title and body

export const tipsRegistry = {
  // Main page tip - shown on first visit to the viewer
  mainPage: {
    key: 'mainPage',
    version: 1,
    titleKey: 'tips.mainPage.title',
    bodyKey: 'tips.mainPage.body',
    trigger: 'onFirstVisit',
  },

  // Settings tool tip
  settings: {
    key: 'settings',
    version: 1,
    titleKey: 'tips.settings.title',
    bodyKey: 'tips.settings.body',
    trigger: 'onToolOpen',
  },

  // Layers tool tip
  layers: {
    key: 'layers',
    version: 1,
    titleKey: 'tips.layers.title',
    bodyKey: 'tips.layers.body',
    trigger: 'onToolOpen',
  },

  // Models tool tip
  models: {
    key: 'models',
    version: 1,
    titleKey: 'tips.models.title',
    bodyKey: 'tips.models.body',
    trigger: 'onToolOpen',
  },

  // Measurements tool tip
  measurements: {
    key: 'measurements',
    version: 1,
    titleKey: 'tips.measurements.title',
    bodyKey: 'tips.measurements.body',
    trigger: 'onToolOpen',
  },

  // Clipping tool tip
  clipping: {
    key: 'clipping',
    version: 1,
    titleKey: 'tips.clipping.title',
    bodyKey: 'tips.clipping.body',
    trigger: 'onToolOpen',
  },

  // Profiler tool tip
  profiler: {
    key: 'profiler',
    version: 1,
    titleKey: 'tips.profiler.title',
    bodyKey: 'tips.profiler.body',
    trigger: 'onToolOpen',
  },

  // Viewpoints tool tip
  viewpoints: {
    key: 'viewpoints',
    version: 1,
    titleKey: 'tips.viewpoints.title',
    bodyKey: 'tips.viewpoints.body',
    trigger: 'onToolOpen',
  },

  // Gaussian Splatting tool tip
  gaussianSplatting: {
    key: 'gaussianSplatting',
    version: 1,
    titleKey: 'tips.gaussianSplatting.title',
    bodyKey: 'tips.gaussianSplatting.body',
    trigger: 'onToolOpen',
  },

  // Annotations tool tip
  annotations: {
    key: 'annotations',
    version: 1,
    titleKey: 'tips.annotations.title',
    bodyKey: 'tips.annotations.body',
    trigger: 'onToolOpen',
  },

  // Transformation tool tip
  transformation: {
    key: 'transformation',
    version: 1,
    titleKey: 'tips.transformation.title',
    bodyKey: 'tips.transformation.body',
    trigger: 'onToolOpen',
  },
};

// Get all tip keys
export const tipKeys = Object.keys(tipsRegistry);

// Get a tip by key
export function getTip(key) {
  return tipsRegistry[key] || null;
}
